import type { PaymentStatus } from '../hooks/usePaymentStatus';
import type { Project } from '../types/project';

/**
 * The paywall gate, in one place.
 *
 * Results has always computed this inline; the Existing Load tab now needs the
 * same answer, because the measured peak is paid content (context/ux.md LOCKED
 * #1) and the two tabs must never disagree about who may see it. A firm
 * subscription covers the people holding its paid SEATS, not everyone whose
 * firm_id happens to be set — see the seat-enforcement note in ResultsView.
 */
export function isSubscribed(status: Pick<PaymentStatus, 'subscription_status' | 'firm_subscription_status' | 'firm_has_seat'>): boolean {
  return (
    status.subscription_status === 'active' ||
    (status.firm_subscription_status === 'active' && status.firm_has_seat)
  );
}

/**
 * True when this project's paid content — the PASS/FAIL result, and the
 * measured peak wherever it appears — may be shown to the signed-in user.
 */
export function isResultsUnlocked(
  project: Pick<Partial<Project>, 'results_unlocked'>,
  status: Pick<PaymentStatus, 'subscription_status' | 'firm_subscription_status' | 'firm_has_seat'>
): boolean {
  return project.results_unlocked === true || isSubscribed(status);
}
